import styled from "@emotion/styled";
export const IconStyled = styled("span", {
  shouldForwardProp: propName => {
    switch (propName) {
      // These are a little confusing to see in the HTML and the CSS so let's filter them out
      // since they don't do anything here as HTML attributes.
      case "height":
      case "width":
      case "color":
      case "svgCss":
      case "cssCustomProperties":
        return false;
      default:
        return true;
    }
  }
})(_ref => {
  let {
    color,
    height,
    width,
    cssCustomProperties
  } = _ref;
  return {
    display: "flex",
    flexShrink: 0,
    color,
    height: `var(--sds--ursa-icons--height, var(--sds--ursa-icons--size, ${height}))`,
    width: `var(--sds--ursa-icons--width, var(--sds--ursa-icons--size, ${width}))`,
    ...cssCustomProperties
  };
}, _ref2 => {
  let {
    svgCss = {}
  } = _ref2;
  return {
    "> svg": {
      overflow: "hidden",
      pointerEvents: "none",
      verticalAlign: "bottom",
      // We're intentionally add this spread here since we control the following props more carefully.
      ...svgCss,
      height: "100%",
      width: "100%"
    }
  };
});
IconStyled.displayName = "IconWrapper";
//# sourceMappingURL=IconStyled.js.map